import { faGear } from '@fortawesome/pro-solid-svg-icons';
import { ComponentProps } from 'react';

import { MenuItem } from '@growtherapy/sprout-ui';

import { IconMenuItem } from '../../components';
import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';

export type ProviderSettingsDrawerMenuItemProps = {
  isSettingsDrawerOpen: boolean;
} & Pick<ComponentProps<typeof MenuItem>, 'onClick'>;

export function ProviderSettingsDrawerControlMenuItem({
  isSettingsDrawerOpen,
  onClick,
}: ProviderSettingsDrawerMenuItemProps) {
  return (
    <IconMenuItem
      aria-controls={PUSH_DRAWER_ARIA_CONTROLS_ID}
      aria-expanded={isSettingsDrawerOpen}
      onClick={onClick}
      icon={faGear}
    >
      <span className='sr-only'>{isSettingsDrawerOpen ? 'Close' : 'Open'} settings</span>
      <span aria-hidden>Settings</span>
    </IconMenuItem>
  );
}
